import { makeBEM } from '../../../utils';

var getClassNameByComponent = function getClassNameByComponent(_ref) {
  var component = _ref.component,
      classPrefix = _ref.classPrefix,
      disabled = _ref.disabled,
      expanded = _ref.expanded;
  var baseClassNames = makeBEM(classPrefix, component);
  var stateClassNames = [];

  if (disabled) {
    stateClassNames.push(makeBEM(classPrefix, component, 'disabled'));
  }

  if (expanded) {
    stateClassNames.push(makeBEM(classPrefix, component, 'expanded'));
  }

  return "".concat(baseClassNames, " ").concat(stateClassNames.join(' ')).trim();
};

export default getClassNameByComponent;